import { createContext, useContext, useEffect, useReducer, useState } from "react"; 
import * as apiSettings from "api/apiSettings";
import { SetSettingsReducerd } from "./reducer/SetSettingsReducer";
import { useToast} from "./ToastContext";
import { useTranslation } from "react-i18next";
import { useGlobal } from "./GlobalContext";
import { useNavigate } from "react-router-dom";
import { setSettingsParamsCache } from "utils/helpers/settings/settingsParamsCache";

const SettingsContext = createContext();
export const useSettings = () => useContext(SettingsContext);

export const SettingsContextProvider = ({children}) => {
  
    const { showToast } = useToast()
    const { t } = useTranslation(['Settings', 'common']);
    const { g } = useGlobal();
    const navigate = useNavigate();

    /** 
     * settings - реальні налаштування
     * localSettings - використовуються для стану форми на сторінці налаштування
     */ 
    const [ settings, setSettings ] = useState(null);
    const [ localSettings, dispatchLocalSettings ] = useReducer(SetSettingsReducerd, null);
    const [ isReady, setIsReady ] = useState(false);
   
    const getModeFieldsFromDirs = (settingsData, mode) => {
        const forms = settingsData?.DIRS?.ModeForms || [];
        const form = forms.find((item) => item.mode === mode)?.fields;
        return Array.isArray(form) ? form : [];
    }

    // Отримуємо параметри з сервреа 
    const getSettings = async () => {
        const resSetting = await apiSettings.getSettings();
        if (!resSetting) return navigate('/login')
        const modeForms = Array.isArray(resSetting?.DIRS?.ModeForms) && resSetting.DIRS.ModeForms.length
            ? resSetting.DIRS.ModeForms
            : await apiSettings.getModeForms();
        const patchedSetting = {
            ...resSetting,
            DIRS: {
                ...(resSetting?.DIRS || {}),
                ModeForms: modeForms,
            },
        };
        const mode = resSetting?.mode || 'general';
        const customModeFields = Array.isArray(patchedSetting?.customModeFields) ? patchedSetting.customModeFields : [];
        const modeFieldsFromResponse = Array.isArray(patchedSetting?.modeFields) ? patchedSetting.modeFields : [];
        const resolvedModeFields = mode === 'general'
            ? []
            : mode === 'custom'
                ? customModeFields
                : (modeFieldsFromResponse.length ? modeFieldsFromResponse : getModeFieldsFromDirs(patchedSetting, mode));
        const preparedSettings = {
            ...patchedSetting,
            mode,
            customModeFields,
            modeFields: resolvedModeFields,
        };
    
        setSettings(preparedSettings);
        setSettingsParamsCache(preparedSettings);
        console.log('preparedSettings', preparedSettings)
        g?.setSettingsMode?.(mode);
        dispatchLocalSettings({type:'SET', settings:preparedSettings});
        setIsReady(true);
    }
 
    // Зберігаємо параметри localSettings
    const saveSettings = async () => {
        const resSetting = await apiSettings.setSettings(localSettings);
        resSetting
            ? showToast(t('messSaved'), 'success')
            : showToast(t('common:messError'),'danger');    
            
        if (resSetting) {
            setSettings(localSettings);
            setSettingsParamsCache(localSettings);
            g?.setSettingsMode?.(localSettings?.mode || 'general');
        }
    }

    // Повертає ID обраної локалізації
    const getLocaleFilterId = () => {
        const aLocales = localSettings?.site?.locales?.split(',');
        const langDef = localSettings?.DIRS?.langs?.find(lang=>lang.langPrefix === aLocales[0]);
        const lang = localSettings?.DIRS?.langs?.find(lang=>lang.langPrefix === g?.localeFilter);
        return lang?.ID || langDef?.ID || 1;
    }
 
    // ХУК - відстеження неіснуючих параметрів
    useEffect(()=>{
        // console.log('SettingsContext', settings)
        // Якщо параметрів немає - отримуємо їх
        if (!settings) getSettings();
        else setSettingsParamsCache(settings);
    }, [settings])

    return isReady 
        ? (<SettingsContext.Provider 
            value={{
                    settings, 
                    setSettings, 
                    saveSettings,
                    localSettings,
                    dispatchLocalSettings,
                    getLocaleFilterId,
                    getSettings}}> 
            {children}
        </SettingsContext.Provider>)
        : (<span className="badge text-bg-primary m-2">Get Settings...</span>);
    

}